<div class="player_container">
  <div class="playback-dropdown" *ngIf="showDropdown">
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '0.25' }" (click)="setPlaybackSpeed(0.25)">
      0.25x
    </div>
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '0.5' }" (click)="setPlaybackSpeed(0.5)">
      0.5x
    </div>
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '1' }" (click)="setPlaybackSpeed(1)">
      Normal
    </div>
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '1.5' }" (click)="setPlaybackSpeed(1.5)">
      1.5x
    </div>
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '2' }" (click)="setPlaybackSpeed(2)">
      2x
    </div>
    <div class="playspeed" [ngClass]="{ active: activePlaybackSpeed == '4' }" (click)="setPlaybackSpeed(4)">
      4x
    </div>
  </div>
  <div class="time-control-box">
    <div class="time-box" *ngIf="tripCurrTime">{{ tripCurrTime }}</div>
    <div class="player-controls">
      <button class="backward" style="background: url({{replayImgSrc}}assets/icons/fast_backward.svg);"
        (click)="handleControl('backward')"></button>
      <button class="pause" style="background: url({{replayImgSrc}}assets/icons/pause.svg);" *ngIf="!isPaused && rangerValue!==tripDetails.actualEndTime"
        (click)="handleControl('pause')"></button>
      <button class="play" style="background: url({{replayImgSrc}}assets/icons/play_arrow.svg);" *ngIf="isPaused && rangerValue!==tripDetails.actualEndTime"
        (click)="handleControl('play')"></button>
      <button *ngIf="rangerValue===tripDetails.actualEndTime" class="forward" style="background: url({{replayImgSrc}}assets/icons/replay.svg)"
        (click)="handleControl('replay')"></button>
        <button class="forward" style="background: url({{replayImgSrc}}assets/icons/fast_forward.svg)"
        (click)="handleControl('forward')"></button>
      <span class="playback-speed" (click)="toggleDropdown()"
        [ngStyle]="{ 'background-color': showDropdown ? '#CFECF9' : '' }">
        {{ playbackSpeed }}x
        <img [src]="replayImgSrc + 'assets/icons/down-carrot.svg'" alt="down-carrot" />
      </span>
    </div>
  </div>
  <div style="overflow: scroll">
    <div class="progress_bar_container" [ngStyle]="{ width: zoom + '%' }">
      <div class="progress_bar">
        <div class="event-icon-box" *ngFor="let icon of iconsList" [ngStyle]="{ 'margin-left': icon.marginLeft + '%' }">
          <img [src]="icon.marker" [alt]="icon?.type" [ngStyle]="{
            'z-index':icon.outOfRange ? 100 : 1
          }"
            *ngIf="(rangerValue >= icon.time || icon.outOfRange) && eventVisibility.get(icon?.type)" />
        </div>
        <div class="event-icon-box" *ngFor="let stop of shuttleStopRelativeTimeStamps; index as index"
          [ngStyle]="{ 'margin-left': stop['marginLeft'] + '%' }">
          <img *ngIf="
              stop.stopType == 'start' &&
              tripDetails.direction === 'OUT' &&
              index == 0
            " [src]="replayImgSrc + 'assets/icons/logout-office.svg'" alt="logout" />
          <img *ngIf="
              stop.stopType == 'last' &&
              tripDetails.direction === 'IN' &&
              index == shuttleStopRelativeTimeStamps.length - 1
            " [src]="replayImgSrc + 'assets/icons/office-marker.svg'" alt="login" />
          <div class="tooltip down" *ngIf="isStopVisible[index]" [ngStyle]="{
              transform:
                stop.marginLeft > 50
                  ? 'translateX(calc(-100% + 16px))'
                  : 'translateX(2%)',
              '--left-value': stop.marginLeft > 50 ? 'calc(100% - 16px)' : '8px'
            }">
            <div>
              {{
              (stop.stopType == "start" && tripDetails.direction == "OUT") ||
              (stop.stopType == "last" && tripDetails.direction == "IN")
              ? "Office"
              : "Stop " + (stop.stopNumber + 1)
              }}
            </div>
            <div>{{ stop["address"] }}</div>
          </div>
          <div class="shuttle-stop" (mousedown)="handleStopMousedown()" (click)="
              handleRangeClick(shuttleStops[stop.stopNumber]?.actualArrivalTime)
            " (mouseout)="toggleShowStop(index)" (mouseover)="toggleShowStop(index)"></div>
        </div>
        <input #ranger id="ranger" type="range" [min]="tripDetails.actualStartTime" [max]="tripDetails.actualEndTime"
          [step]="1000" [value]="rangerValue" (input)="handleRange(ranger.value)" (mousedown)="handleMouseDown()"
          (mouseup)="handleRangeClick(rangerValue)" />
      </div>
      <div class="time-stamps">
        <div *ngFor="let timestamp of timestamps; index as index" class="d-flex just-center align-center flex-dir-col">
          <div class="stroke"></div>
          {{ timestamp }}
        </div>
      </div>

      <div class="start-end-text-box">
        <ng-container *ngIf="tripDetails['direction'] === 'OUT'; else loginBlock">
          <div>Office</div>
          <div>Last Stop</div>
        </ng-container>
        <ng-template #loginBlock>
          <div>First Stop</div>
          <div>Office</div>
        </ng-template>
      </div>
      <div class="zoom-box">
        <img [src]="replayImgSrc + 'assets/icons/zoom_out.svg'" alt="zoom_out" />
        <input #zoomer id="zoomer" type="range" [min]="100" [max]="500" [step]="100" [value]="zoom"
          (input)="handleZoom(zoomer.value)" />
        <img [src]="replayImgSrc + 'assets/icons/zoom_in.svg'" alt="zoom_in" />
      </div>
    </div>
  </div>
</div>